/**
 * @generated SignedSource<<3de5d0eca3f8123e685a1a1664a84d5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillingStatus = "billed" | "unbilled" | "%future added value";
export type Currency = "BRL" | "USD" | "%future added value";
export type DashboardPageUpdateMutation$variables = {
  billingStatus?: BillingStatus | null | undefined;
  currency?: Currency | null | undefined;
  date?: string | null | undefined;
  description?: string | null | undefined;
  duration?: string | null | undefined;
  endDate?: string | null | undefined;
  hourlyRate?: number | null | undefined;
  id: string;
  memberIds?: ReadonlyArray<string> | null | undefined;
  projectId?: string | null | undefined;
  title?: string | null | undefined;
};
export type DashboardPageUpdateMutation$data = {
  readonly updateTask: {
    readonly billingStatus: BillingStatus;
    readonly date: string;
    readonly durationMinutes: number;
    readonly id: string;
    readonly title: string;
    readonly totalAmount: number;
  };
};
export type DashboardPageUpdateMutation = {
  response: DashboardPageUpdateMutation$data;
  variables: DashboardPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billingStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currency"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "duration"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hourlyRate"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberIds"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "billingStatus",
        "variableName": "billingStatus"
      },
      {
        "kind": "Variable",
        "name": "currency",
        "variableName": "currency"
      },
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      },
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "duration"
      },
      {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "hourlyRate",
        "variableName": "hourlyRate"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "memberIds",
        "variableName": "memberIds"
      },
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "updateTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingStatus",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardPageUpdateMutation",
    "selections": (v11/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v10/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "DashboardPageUpdateMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "25a7bd4c653b6d7a94958de70dfe9fac",
    "id": null,
    "metadata": {},
    "name": "DashboardPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation DashboardPageUpdateMutation(\n  $id: ID!\n  $title: String\n  $description: String\n  $date: String\n  $endDate: String\n  $duration: String\n  $projectId: ID\n  $hourlyRate: Float\n  $currency: Currency\n  $billingStatus: BillingStatus\n  $memberIds: [ID!]\n) {\n  updateTask(id: $id, title: $title, description: $description, date: $date, endDate: $endDate, duration: $duration, projectId: $projectId, hourlyRate: $hourlyRate, currency: $currency, billingStatus: $billingStatus, memberIds: $memberIds) {\n    id\n    title\n    date\n    durationMinutes\n    totalAmount\n    billingStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1b4922fd5351aaf275d46d5fb2b3b4e";

export default node;
